export default __webpack_public_path__ + "static/biophilia-logo-e043f7d0c9a4184d601204e5dab29e18.png";